<template>
  <popup @codd_close="$emit('close')">
    <div class="title">{{ $t('popupClosedFrameQuote.title') }}</div>
    <div class="custom-closed-frame-popup">
      <div class="form-group">
        <label for="name">{{ $t('cylinder.quotationPopup.name') }}</label>
        <input type="text" id="name" name="name" v-model="form.name">
        <span class="error" v-if="errors['name']" v-for="error in this.errors['name']">{{ error }}</span>
      </div>
      <div class="form-group">
        <label for="company">{{ $t('cylinder.quotationPopup.company') }}</label>
        <input type="text" id="company" name="company" v-model="form.companyName">
        <span class="error" v-if="errors['companyName']" v-for="error in this.errors['companyName']">{{ error }}</span>
      </div>
      <div class="form-group">
        <label for="address">{{ $t('cylinder.quotationPopup.address') }}</label>
        <input type="text" id="address" name="address" v-model="form.address">
        <span class="error" v-if="errors['address']" v-for="error in this.errors['address']">{{ error }}</span>
      </div>
      <div class="form-group">
        <label for="zipcode">{{ $t('cylinder.quotationPopup.zipcode') }}</label>
        <input type="text" id="zipcode" name="zipcode" v-model="form.zipcode">
        <span class="error" v-if="errors['zipcode']" v-for="error in this.errors['zipcode']">{{ error }}</span>
      </div>
      <div class="form-group">
        <label for="city">{{ $t('cylinder.quotationPopup.city') }}</label>
        <input type="text" id="city" name="city" v-model="form.city">
        <span class="error" v-if="errors['city']" v-for="error in this.errors['city']">{{ error }}</span>
      </div>
      <div class="form-group">
        <label for="phone">{{ $t('cylinder.quotationPopup.phone') }}</label>
        <input type="tel" id="phone" name="phone" v-model="form.phonenumber">
        <span class="error" v-if="errors['phonenumber']" v-for="error in this.errors['phonenumber']">{{ error }}</span>
      </div>
      <div class="form-group">
        <label for="email">{{ $t('cylinder.quotationPopup.email') }}</label>
        <input type="email" id="email" name="email" v-model="form.email">
        <span class="error" v-if="errors['email']" v-for="error in this.errors['email']">{{ error }}</span>
      </div>
      <div class="form-group">
        <label for="country">{{ $t('cylinder.quotationPopup.country') }}</label>
        <input type="text" id="country" name="country" v-model="form.country">
        <span class="error" v-if="errors['country']" v-for="error in this.errors['country']">{{ error }}</span>
      </div>
      <div class="form-group">
        <label for="message">{{ $t('cylinder.quotationPopup.message') }}</label>
        <textarea rows="4" id="message" name="message" v-model="form.message"/>
      </div>
      <div>
        <span class="error" v-if="errors['generic']" v-for="error in this.errors['generic']">{{ error }}</span>
      </div>
      <div class="button-wrapper">
        <button class="add-btn" @click="submitClosedFrameForm">
          {{ $t('popupClosedFrameQuote.submit') }}
        </button>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from "@/components/popup/Popup";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "PopupClosedFrameQuote",

  components: {Popup},

  data() {
    return {
      form: {
        email: '',
        name: '',
        companyName: '',
        zipcode: '',
        address: '',
        city: '',
        phonenumber: '',
        country: '',
        message: '',
      },
      errors: [],
    }
  },

  methods: {
    async submitClosedFrameForm() {
      const buildId = await this.$store.dispatch('cart/getBuildId');

      const data = {
        ...this.form,
        buildId,
      };

      this.errors = [];

      await axios.post(process.env.VUE_APP_API_URL + 'closed-frame-form', {
        ...data,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-*': '*',
        }
      }).then((response) => {
        Swal.fire({
          title: this.$t('popupClosedFrameQuote.successTitle'),
          text: this.$t('popupClosedFrameQuote.successText'),
          icon: 'success',
          confirmButtonColor: '#3DB0C7',
        });
        this.$emit('close');
      }).catch((error) => {
        if (error.response.status === 422) {
          this.errors = error.response.data?.errors || [];
          return;
        }

        this.errors = {
          generic: 'Er is iets mis gegaan, probeer het later opnieuw.'
        };
      });
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  display: block;
  padding: 20px;
  font-size: 20px;
  font-family: neue-haas-grotesk-display, sans-serif;
  font-weight: 700;
}

.custom-closed-frame-popup {
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat( auto-fit, minmax(250px, 1fr) );
  column-gap: 12px;
  margin: 0 18px;

  label {
    font-family: neue-haas-grotesk-display, sans-serif;
    font-weight: 700;
    font-size: 14px;
  }

  input {
    width: 100%;
    max-height: 40px;
    border: 2px solid #ebebeb;
    outline: none;
    border-radius: 25px;
    padding: 18px;
  }

  textarea {
    width: 100%;
    border: 2px solid #ebebeb;
    outline: none;
    border-radius: 10px;
    padding: 18px;
  }

  input, textarea {
    font-family: neue-haas-grotesk-text, sans-serif;
    font-weight: 400;
    font-size: 14px;
  }

  .error {
    color: red;
    font-size: 12px;
    font-family: neue-haas-grotesk-text, sans-serif;
    font-weight: 400;
  }

  .button-wrapper {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-bottom: 22px;

    button {
      border-radius: 5px;
      color: #fff;
      border: none;
      height: 36px;
      padding: 0 10px;
      font-size: 14px;
      font-family: neue-haas-grotesk-display, sans-serif;
      transition: all .3s ease;
      letter-spacing: .5px;
      background-color: #71bc03;
      outline: none;

      &:hover {
        background-color: #5a9e02;
      }
    }
  }
}
</style>